<template>
  <v-row
    no-gutters
    :class="ctasBancarias[posMedio].address.length > 1 && pos > 0 ? 'mt-4' : ''"
  >
    <v-col
      cols="12"
      md="11"
    >
      <v-text-field
        v-model="address.address"
        :label="`${pos === 0 ? $t('lbl.address') : `${$t('lbl.address')} - ${$t('lbl.line')} ${pos + 1}`}`"
        hide-details:label="$t('lbl.address')"
        outlined
        dense
        hide-details="auto"
      ></v-text-field>
    </v-col>
    <v-col
      v-if="pos === 0"
      cols="12"
      md="1"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            x-small
            class="ml-2"
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="addAddressCtasBancarias(posMedio)"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.insert') }}</span>
      </v-tooltip>
    </v-col>
    <v-col
      v-if="pos > 0"
      cols="12"
      md="1"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            x-small
            class="ml-2"
            color="error"
            v-bind="attrs"
            v-on="on"
            @click="deleteAddressCtasBancarias({ pos: posMedio, posA: pos })"
          >
            <v-icon small>
              {{ icons.mdiTrashCan }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.delete') }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiPlus,
  mdiArrowLeft,
  mdiSquareEditOutline,
  mdiDeleteOutline,
  mdiUpdate,
  mdiCalendarRange,
  mdiCancel,
  mdiDomain,
  mdiMenuDown,
  mdiMenuRight,
  mdiTrashCan,
} from '@mdi/js'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    address: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    posMedio: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    pos: {
      type: Number,
    },
  },
  data() {
    return {
      rutaPublic: process.env.VUE_APP_API_URL_PLUBLIC,
      isLoading: true,
      isLoadingSuplementos: true,
      isDialogSuplemento: false,
      icons: {
        mdiPlus,
        mdiArrowLeft,
        mdiSquareEditOutline,
        mdiDeleteOutline,
        mdiUpdate,
        mdiCalendarRange,
        mdiCancel,
        mdiDomain,
        mdiMenuDown,
        mdiMenuRight,
        mdiTrashCan,
      },
      loading: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      rols: [],
      products: [],
    }
  },
  computed: {
    ...mapState({
      ctasBancarias: state => state.app.ctasBancarias,
    }),
  },
  methods: {
    ...mapMutations(['addAddressCtasBancarias', 'deleteAddressCtasBancarias']),
  },
}
</script>
<style scoped>
::v-deep .my-input .v-label,
::v-deep .my-input input {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
::v-deep .v-text-field__details {
  padding: 0 0 0 0;
}
</style>
